/**
 * ICON OVERRIDE
 * Forces the replacement of the Flask icon (🧪) with Table + Magnifying Glass (🪑🔍)
 * wherever it appears in the UI, specifically targeting the WorkBoard launch button.
 */
(function () {
    const TARGET_ICON = '🧪';
    const NEW_ICON = '🟫🔍';

    function replaceIcons() {
        // 1. Check all buttons
        const buttons = document.querySelectorAll('button, .btn, .bubble-btn');
        buttons.forEach(btn => {
            if (btn.textContent.includes(TARGET_ICON) || btn.innerHTML.includes(TARGET_ICON)) {
                console.log('🔄 Replaced icon in button:', btn);
                btn.innerHTML = btn.innerHTML.replace(TARGET_ICON, NEW_ICON);
            }
        });

        // 2. Check all spans/divs with specific classes if any
        const icons = document.querySelectorAll('.btn-icon, .emoji');
        icons.forEach(icon => {
            if (icon.textContent.includes(TARGET_ICON)) {
                icon.textContent = icon.textContent.replace(TARGET_ICON, NEW_ICON);
            }
        });
    }

    // Run on load
    document.addEventListener('DOMContentLoaded', () => {
        replaceIcons();

        // Run periodically to catch dynamic additions
        setInterval(replaceIcons, 1000);
    });

    // Also run immediately in case it's late
    replaceIcons();
})();
